import { faLayerGroup } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Box,
    MenuItemProps,
    MenuItem as MuiMenuItem,
    Select as MuiSelect,
    SelectProps,
    styled,
    Typography,
} from "@mui/material";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useGetAllMaps } from "src/api/map";
import { MapContext } from "src/contexts/map";
import { URL_LIST_VIEW, URL_MAP_VIEW } from "src/router/routes";
import { Type_Map_Formatted } from "src/types/map";

const Select = styled(MuiSelect)<SelectProps>(({ theme }) => ({
    width: theme.spacing(25),
}));

const MenuItem = styled(MuiMenuItem)<MenuItemProps>(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));

const LayersList = () => {
    const { data: maps, isLoading } = useGetAllMaps();
    const navigate = useNavigate();
    const location = useLocation();
    const { schema } = useParams<{ schema: string }>();

    const isLocationMapOrList =
        location.pathname === `/${schema}${URL_MAP_VIEW}` ||
        location.pathname === `/${schema}${URL_LIST_VIEW}`;

    const { selectedMap, updateSelectedMap, updateMaps, updateNewElement } =
        useContext(MapContext);

    useEffect(() => {
        if (!isLoading) {
            updateMaps(maps);
            updateSelectedMap(maps[0]);
        }
    }, [isLoading]);

    const handleItemClick = (map: Type_Map_Formatted) => {
        sessionStorage.removeItem("currentZoom");
        sessionStorage.removeItem("currentCenter");
        if (!isLocationMapOrList) navigate(`/${schema}${URL_MAP_VIEW}`);
        updateSelectedMap(map);
    };

    return (
        <>
            <Select
                size="small"
                value={selectedMap?.id || ""}
                renderValue={() => (
                    <Box display="flex" alignItems="center" gap={1}>
                        <FontAwesomeIcon icon={faLayerGroup} />
                        <Typography color="text.secondary">
                            {selectedMap?.label}
                        </Typography>
                    </Box>
                )}
            >
                {!isLoading &&
                    maps.map((map: Type_Map_Formatted) => (
                        <MenuItem
                            disableRipple
                            key={map.id}
                            value={map.id}
                            onClick={() => {
                                handleItemClick(map);
                                updateNewElement(null);
                            }}
                        >
                            {map.label}
                        </MenuItem>
                    ))}
            </Select>
        </>
    );
};

export default LayersList;
